import React from "react";
import styled from "styled-components";
import BaseComponent from "../BaseComponent";
import PillButton from "./PillButton";

const Wrapper = styled.div`
  display: flex;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  flex-direction: row;
  margin-bottom: 6px;
  margin-top: 0px;
  margin-left: 21px;
  margin-right: 21px;
  background-color: white;
`;

const LeftPanel = styled.div`
  display: flex;
  flex-direction: row;
`;

const RightPanel = styled.div``;

const SubscriberName = styled.div`
  color: black;
  font-weight: bold;
  display: inline;
`;

class Subscriber extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.validDate = this.validDate.bind(this);
  }

  validDate(dateValue) {
    return dateValue != null && new Date(dateValue) > new Date();
  }

  render() {
    return (
      <Wrapper>
        <LeftPanel>
          <SubscriberName>
            {this.props.item.firstName + " " + this.props.item.lastName}
          </SubscriberName>
        </LeftPanel>
        <RightPanel>
          {this.props.item.confirmed === 0 ? (
            <>
              <PillButton
                onClick={this.props.confirmCallback}
                style={{
                  width: 80,
                  backgroundColor: "white",
                  borderColor: "#1cbff2",
                  borderWidth: 2,
                  borderStyle: "solid",
                }}
              >
                {"Confirm"}
              </PillButton>
              <PillButton
                onClick={this.props.declineCallback}
                style={{
                  width: 80,
                  backgroundColor: "white",
                  borderColor: "#1cbff2",
                  borderWidth: 2,
                  borderStyle: "solid",
                }}
              >
                {"Decline"}
              </PillButton>
            </>
          ) : null}
        </RightPanel>
      </Wrapper>
    );
  }
}

export default Subscriber;
